"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NucleusPreferences = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FormikColumnFormatField_1 = __importDefault(require("../../../elements/formik/FormikColumnFormatField"));
const NucleusGroup_1 = require("./NucleusGroup");
function NucleusPreferences({ nucleus, fields, renderTop, renderBottom, }) {
    return ((0, jsx_runtime_1.jsx)(NucleusGroup_1.NucleusGroup, { nucleus: nucleus, renderTop: renderTop, renderBottom: renderBottom, children: fields.map((field) => ((0, jsx_runtime_1.jsx)(FormikColumnFormatField_1.default, { label: field.label, checkControllerName: field.checkControllerName &&
                `nuclei.${nucleus}.${field.checkControllerName}`, formatControllerName: field.formatControllerName &&
                `nuclei.${nucleus}.${field.formatControllerName}`, hideCheckField: field.hideCheckField, hideFormatField: field.hideFormatField, disableFormat: field.disableFormat }, field.id))) }));
}
exports.NucleusPreferences = NucleusPreferences;
